import React from 'react';
import { connect } from 'react-redux';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import { userActions } from '../_actions';
import { MainPage } from '../MainPage';
import { TopNav } from '../TopNav';
import Footer from '../components/common/Footer';
import { withCookies } from "react-cookie";

class HomePage extends React.Component {
  componentDidMount() {
    // this.props.dispatch(userActions.getAll());
    // const mycookie = this.props.cookies
    // this.props.dispatch(userActions.login("ABHG48", "test", "123456"));
    // const companyCode = mycookie.cookies.companyCode
    //
    // this.props.dispatch(userActions.token("ABHG48"));
  }

  handleDeleteUser(id) {
    return e => this.props.dispatch(userActions.delete(id));
  }

  // position: relative; height: calc(100vh - 50px);
  render() {
    const { user, users } = this.props;
    return (
      <div>
        {/* <TopNav /> */}
        <MainPage />
        {/* <div className="clearfix" /> */}
        {/* <Footer /> */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication } = state;
  const { user } = authentication;
  return {
    user,
    users
  };
}

const connectedHomePage = withCookies(connect(mapStateToProps)(HomePage));
export { connectedHomePage as HomePage };
